<template>
  <!-- Pop-up Dialog for archiving cohorts -->
  <HvhModal :value="true" title="Archive Cohorts" max-width="720" @input="$emit('input', false)">
    <template v-slot>
      <p>
        You are about to archive <b>{{ name }}</b> cohort. <br /><br />
        This action cannot be undone. Do you still want to archive cohort?
      </p>
    </template>
    <template v-slot:actions>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('input', false)">Cancel</v-btn>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('archive-all-versions')">Archive All Versions</v-btn>
      <v-btn flat class="hvh-btn hvh-btn--primary" @click="$emit('archive')">Archive Current Version</v-btn>
    </template>
  </HvhModal>
</template>

<script>
import HvhModal from '../../common/modal/HvhModal.vue';
export default {
  components: { HvhModal },
  props: ['name'],
}
</script>